import { IUserConfirmation } from "@fl/shared/src/types/usuarios";
import { yupResolver } from "@hookform/resolvers/yup";
import React, { useEffect, useState } from "react";
import { Button, Form } from "react-bootstrap";
import { SubmitHandler, useForm } from "react-hook-form";
import { useLocation, useNavigate } from "react-router-dom";
import { confirmaSchema } from "../../schemas/users";
import ApiUsers from "../../services/suporte/users";
import ParamsFuncs from "../../utils/paramsFuncs";
import DefaultBasePage from "../default/base"; // ajuste o caminho conforme necessário

export type ConfirmacaoFormInputs = IUserConfirmation;

const ConfirmUserPage: React.FC = () => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm<ConfirmacaoFormInputs>({
    resolver: yupResolver(confirmaSchema),
  });

  const onSubmit: SubmitHandler<ConfirmacaoFormInputs> = async (data) => {
    try {
      setLoading(true);
      const result = await new ApiUsers(data).confirm();
      navigate("/", { state: result });
    } finally {
      setLoading(false);
    }
  };

  const search = useLocation().search;

  useEffect(() => {
    const { id, codigo } = new ParamsFuncs(search).getConfirmUser();
    if (id) setValue("id", parseInt(id)); //Inserção manual de valores no hook
    if (codigo) setValue("codigo", codigo);
    onSubmit({ codigo: codigo!, id: parseInt(id!) });
  }, []);

  return (
    <DefaultBasePage title="Confirmação de Usuário" loading={loading}>
      <div className="d-flex justify-content-center">
        <Form onSubmit={handleSubmit(onSubmit)} noValidate>
          <Form.Group controlId="formId">
            <Form.Label>ID:</Form.Label>
            <Form.Control
              type="number"
              placeholder="ID do usuário"
              {...register("id")}
              isInvalid={!!errors.id}
            />
            <Form.Control.Feedback type="invalid">
              {errors.id?.message}
            </Form.Control.Feedback>
          </Form.Group>

          <Form.Group controlId="formCode" className="mt-3">
            <Form.Label>Código:</Form.Label>
            <Form.Control
              type="text"
              placeholder="Código de validação"
              {...register("codigo")}
              isInvalid={!!errors.codigo}
            />
            <Form.Control.Feedback type="invalid">
              {errors.codigo?.message}
            </Form.Control.Feedback>
          </Form.Group>

          <div className="d-flex justify-content-end">
            <Button variant="outline-success" type="submit" className="mt-4">
              Ativar Usuário
            </Button>
          </div>
        </Form>
      </div>
    </DefaultBasePage>
  );
};

export default ConfirmUserPage;
